import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'

import NowShippingModalContainer from '.'

export default ({ container, i18n, searchResultUpid }) => {
  hydrateWithHOCs({
    container,
    i18n,
  })(<NowShippingModalContainer searchResultUpid={searchResultUpid} />)
}
